<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  export let label;
  export let labelHint = '';
  export let defaultCount = 0;
  export let minValue = 0;

  const labelId = label.toLowerCase();

  $: value = defaultCount;
  $: disabledDecrement = value === minValue;
  $: if (value >= minValue) {
    dispatch('number-of-guest', { count: value });
  }

  const increment = () => (value = value + 1);
  const decrement = () => (value = value - 1);
</script>

<div class="d-flex flex-justify-between flex-items-center mb-3">
  <label
    class="col-5 lh-condensed"
    for="availability-guestpicker-{labelId}-input"
    data-testid="availability-guestpicker-{labelId}-label">
    <span class="d-block f4 poppins-font">{label}</span>
    {#if labelHint}<span class="f5 text-gray-light">{labelHint}</span>{/if}
  </label>
  <div class="d-flex">
    <input
      id="availability-guestpicker-{labelId}-input"
      class="outline-focus border-0 poppins-font f4 text-center flex-order-1"
      type="text"
      name=""
      size="2"
      {value}
      min={minValue}
      data-behavior="availability-guestpicker-input"
      data-testid="availability-guestpicker-{labelId}-input"
      on:input={(event) =>
        (value = !isNaN(parseInt(event.currentTarget.value))
          ? parseInt(event.currentTarget.value)
          : 0)} />
    <button
      class="bttn bttn-sm bg-white mr-1 p-md-2 lh-condensed flex-shrink-0"
      type="button"
      aria-label="Decrease value"
      aria-controls="availability-guestpicker-{labelId}-input"
      data-behavior="availability-guestpicker-decrease-button"
      data-testid="availability-guestpicker-{labelId}-decrease-button"
      data-for="availability-guestpicker-{labelId}-input"
      disabled={disabledDecrement}
      on:click={decrement}>
      <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        width="16"
        height="16"
        role="presentation"
        fill="none"
        stroke="currentcolor"
        stroke-width="5.333"
        overflow="visible"><path d="M2 16h28" /></svg>
    </button>
    <button
      class="bttn bttn-sm bg-white ml-1 p-md-2 flex-order-2 lh-condensed flex-shrink-0"
      type="button"
      aria-label="Increase value"
      aria-controls="availability-guestpicker-{labelId}-input"
      data-behavior="availability-guestpicker-increase-button"
      data-testid="availability-guestpicker-{labelId}-increase-button"
      data-for="availability-guestpicker-{labelId}-input"
      on:click={increment}>
      <svg
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        width="16"
        height="16"
        fill="none"
        stroke="currentcolor"
        stroke-width="5.333"
        overflow="visible"><path d="M2 16h28M16 2v28" /></svg>
    </button>
  </div>
</div>
